import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { of, Subject, ReplaySubject, Observable } from "rxjs";
import { tap, map, take, takeUntil } from 'rxjs/operators';
import { AuthService } from "../services/data/auth.service";
import { Claims } from '../types';
import { UnsubscribeOnDestroy } from "../classes";

@Injectable({
    "providedIn": "root"
})
export class AccessGuard extends UnsubscribeOnDestroy implements CanActivate {
    private authService = inject(AuthService);
    private router = inject(Router);
    
    constructor() { super(); }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const requiresLogin = route.data.requiresLogin || false;

        if (!requiresLogin) return of(true)

        const requiredClaim = route.data.requiresClaim || null;
        const requiresAllMarkets = route.data.requiresAllMarkets || false;
        let isAuthenticated = false;
        let isAuthorized = false;

        // check to make sure the user is logged in
        return this.authService.isUserLoggedIn()
            .pipe(
                tap((authenticated: boolean) => {
                    isAuthenticated = authenticated;

                    if (isAuthenticated && requiredClaim !== null && requiresAllMarkets === true) {
                        const isOrgAll: boolean = this.authService.getClaimValue(Claims.orgAll);
                        const hasClaim = this.authService.hasClaims([requiredClaim])
                        isAuthorized = hasClaim && isOrgAll;
                    } else if (isAuthenticated && requiredClaim !== null && requiresAllMarkets === false) {
                        const hasClaim = this.authService.hasClaims([requiredClaim]);
                        isAuthorized = hasClaim
                    } else if (isAuthenticated) {
                        isAuthorized = true;
                    }

                    if (isAuthorized) {
                        return of(true)
                    }

                    if (isAuthenticated && !isAuthorized) {
                        return this.router.navigateByUrl("/forbidden");
                    }

                    // user is not authenticated - does not have a CP role
                    return this.router.navigateByUrl('/unauthorized');
                }));
    }
}
